import { Link } from 'react-router-dom';
import { ButtonBase } from '@mui/material';
import logo from 'assets/images/logos/Logos CardioID/VersaoNegativo_HeartmetricsExperts_RGB.png';
import config from 'config';

// ==============================|| MAIN LOGO ||============================== //

function CompanySection() {
    return (
        <ButtonBase
            disableRipple
            component={Link}
            to={config.company}
            target="_blank"
            rel="noopener noreferrer"
        >
            <img src={logo} alt="Berry" width="200px" height="100%" />;
        </ButtonBase>
    );
}

export default CompanySection;
